import { collection, where } from 'firebase/firestore';
import { firestore } from 'firebaseService/firebase';
import FirebaseFirestoreService from 'firebaseService/firebaseFirestore';

class DependencyService extends FirebaseFirestoreService {
  static collectionPath = 'dependencies';
  static collection = collection(firestore, this.collectionPath);

  static async createDependency(values) {
    try {
      return await this.addDoc(this.collection, { ...values });
    } catch (error) {
      return { success: false, error };
    }
  }

  static async updateDependency(id, dependency) {
    try {
      return await this.updateDoc(this.collectionPath, id, { ...dependency });
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static async getDependencies(dependency) {
    try {
      const constrains = [where('dependence', '==', dependency)];
      const result = await this.getAllDocs(this.collection, constrains);
      return result.find((dep) => dep.dependence.toLowerCase().includes(dependency.toLowerCase()));
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static async getDependenciesChildren(dependency) {
    try {
      const constrains = [where('parent', '==', dependency)];
      return await this.getAllDocs(this.collection, constrains);
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static subscribeToDependencies(callBack) {
    try {
      const constrains = [];
      const unsubscibe = FirebaseFirestoreService.subscribeToAllDocs(this.collection, constrains, callBack);
      return unsubscibe;
    } catch (error) {
      return { success: false, error };
    }
  }
}

export default DependencyService;
